import React, { useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@mui/material'

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}

const Forgot = (props) => {
  const { auth } = useFirebase()
  const { resetPassword } = auth

  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)

  const sendPasswordResetEmail = async () => {
    resetPassword(email)
    setEmailSent(true)
  }

  return (
    <Grid container alignItems='center' spacing={0} style={{ backgroundImage: `url('/assets/images/main_background.png')`, backgroundRepeat: 'repeat', backgroundSize: 'cover' }} sx={{ minHeight: '100vh' }}>
      <Grid item xs={12}>
        <Container maxWidth='sm'>
        <Card sx={{ p: 2 }}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant='h4' gutterBottom>
                    ¿Olvidaste tu contraseña?
                  </Typography>
                  <Typography variant='body1' gutterBottom>
                    { emailSent ? `Por favor revisa tu correo, hemos mandado las instrucciones para reestablecer tu contraseña a ${email}.` : 'No te preocupes, te mandaremos las instrucciones para reestablecerla.' }
                  </Typography>
                </Grid>
                <Grid item xs={12} sx={{ display: emailSent ? 'none' : 'block' }}>
                  <TextField
                    id='outlined-email-input'
                    InputLabelProps={{ shrink: true }}
                    label='Email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder='Ingresa tu email'
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: emailSent ? 'none' : 'block' }}>
                  <Grid container direction='row' justifyContent='flex-end'>
                    <Button color='lightPurple' disabled={!validateEmail(email)} variant='contained' disableElevation onClick={sendPasswordResetEmail}>
                      Reestablecer
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ pt: 4 }} variant='body1'>
                    <Link sx={{ fontWeight: 'bolder', textDecoration: 'none' }} href='/login'>Volver a inicio de sesión</Link>
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Grid>
    </Grid>
  )
}

export default Forgot